// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host pdf-viewer {
  width: 100%;
  height: 100%;
}
:host pdf-viewer ::ng-deep .page {
  box-sizing: initial;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/global/pdf-modal/pdf-modal.page.scss"],"names":[],"mappings":"AACE;EACE,WAAA;EACA,YAAA;AAAJ;AAEI;EACE,mBAAA;AAAN","sourcesContent":[":host {\n  pdf-viewer {\n    width: 100%;\n    height: 100%;\n\n    ::ng-deep .page {\n      box-sizing: initial;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
